// removed by extract-text-webpack-plugin
module.exports = {"overlay":"overlay__overlay-ccjqX","isLoading":"overlay__isLoading-1OxGj"};


//////////////////
// WEBPACK FOOTER
// ./components/layout/overlay/overlay.css
// module id = 842
// module chunks = 0